import React, { useState } from 'react';
import { ShoppingBag, User, Heart, Search, Menu, X, ArrowRight, ChevronRight, Star, Truck, Shield, RotateCcw, Plus, Grid3X3 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template20 = () => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [hoveredProduct, setHoveredProduct] = useState(null);
    const [activeBrand, setActiveBrand] = useState('all');

    const brands = [
        { id: 'all', name: 'All Brands' },
        { id: 'fabindia', name: 'FabIndia' },
        { id: 'biba', name: 'BIBA' },
        { id: 'wforwoman', name: 'W' },
    ];

    const featuredBrands = [
        { name: 'FabIndia', products: '1,200+', image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&h=400&fit=crop' },
        { name: 'BIBA', products: '850+', image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=600&h=400&fit=crop' },
        { name: 'W for Woman', products: '720+', image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=600&h=400&fit=crop' },
        { name: 'Manyavar', products: '640+', image: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=600&h=400&fit=crop' },
        { name: 'Allen Solly', products: '980+', image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=600&h=400&fit=crop' },
        { name: 'Raymond', products: '560+', image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=600&h=400&fit=crop' },
    ];

    const categories = [
        { name: 'Women', count: '4,500+', image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=700&fit=crop' },
        { name: 'Men', count: '3,200+', image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=700&fit=crop' },
        { name: 'Kids', count: '1,800+', image: 'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=500&h=700&fit=crop' },
    ];

    const products = [
        { name: 'Block Print Kurta Set', brand: 'FabIndia', price: 3299, originalPrice: 4199, image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop', rating: 4.5, reviews: 234, tag: 'Bestseller' },
        { name: 'Printed Anarkali', brand: 'BIBA', price: 2899, originalPrice: 3699, image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&h=650&fit=crop', rating: 4.7, reviews: 189, tag: null },
        { name: 'Fusion Tunic', brand: 'W', price: 1999, originalPrice: 2599, image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500&h=650&fit=crop', rating: 4.4, reviews: 312, tag: 'New' },
        { name: 'Cotton Palazzo Set', brand: 'FabIndia', price: 2599, originalPrice: 3299, image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=650&fit=crop', rating: 4.6, reviews: 156, tag: null },
        { name: 'Embroidered Kurta', brand: 'BIBA', price: 2199, originalPrice: 2799, image: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=650&fit=crop', rating: 4.5, reviews: 278, tag: 'Sale' },
        { name: 'Linen Shirt Dress', brand: 'W', price: 2499, originalPrice: 3199, image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop', rating: 4.3, reviews: 198, tag: null },
        { name: 'Chanderi Dupatta Set', brand: 'FabIndia', price: 4499, originalPrice: 5699, image: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=500&h=650&fit=crop', rating: 4.8, reviews: 423, tag: 'Premium' },
        { name: 'Asymmetric Kurti', brand: 'W', price: 1799, originalPrice: 2299, image: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=500&h=650&fit=crop', rating: 4.2, reviews: 167, tag: 'New' },
    ];

    const services = [
        { icon: Truck, title: 'Free Shipping', desc: 'On orders above ₹999' },
        { icon: Shield, title: '100% Authentic', desc: 'Genuine products only' },
        { icon: RotateCcw, title: 'Easy Returns', desc: '15-day return policy' },
    ];

    const reviews = [
        { text: 'Amazing collection of brands under one roof. The quality and authenticity is guaranteed. Love shopping here!', name: 'Sneha Kapoor', city: 'Mumbai', rating: 5 },
        { text: 'Found my entire wedding wardrobe here. Great discounts and genuine products from all my favorite brands.', name: 'Priya Sharma', city: 'Delhi', rating: 5 },
        { text: 'Super fast delivery and excellent packaging. Customer service is very responsive. Highly recommend!', name: 'Kavitha Reddy', city: 'Bangalore', rating: 5 },
    ];

    return (
        <div className="w-full min-h-screen bg-white font-sans">
            {/* Top Bar */}
            <div className="bg-slate-900 text-white text-center py-2 text-xs tracking-wide">
                FREE SHIPPING ON ORDERS OVER ₹999 | 50+ PREMIUM BRANDS
            </div>

            {/* Header */}
            <header className="bg-white sticky top-0 z-50 border-b border-slate-200">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="flex items-center justify-between px-4 lg:px-8 py-4">
                        {/* Mobile Menu */}
                        <button className="lg:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                            {mobileMenuOpen ? <X className="w-6 h-6 text-slate-900" /> : <Menu className="w-6 h-6 text-slate-900" />}
                        </button>

                        {/* Logo */}
                        <h1 onClick={() => navigate('/template20')} className="text-2xl lg:text-3xl font-black tracking-tight text-slate-900 cursor-pointer">
                            SUPREME
                        </h1>

                        {/* Desktop Nav */}
                        <nav className="hidden lg:flex items-center gap-8">
                            <button onClick={() => navigate('/template20/shop')} className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                Shop All
                            </button>
                            <button className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                Brands
                            </button>
                            <button className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                Women
                            </button>
                            <button className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                Men
                            </button>
                            <button className="text-sm font-medium text-red-600 hover:text-red-700 transition-colors">
                                Sale
                            </button>
                        </nav>

                        {/* Search & Icons */}
                        <div className="flex items-center gap-4">
                            <div className="hidden lg:flex items-center bg-slate-100 rounded-lg px-4 py-2">
                                <Search className="w-4 h-4 text-slate-400" />
                                <input type="text" placeholder="Search brands, products..." className="bg-transparent border-0 text-sm ml-2 focus:outline-none w-48" />
                            </div>
                            <Search className="w-5 h-5 text-slate-700 cursor-pointer lg:hidden" />
                            <User className="w-5 h-5 text-slate-700 cursor-pointer hover:text-slate-900 transition-colors hidden sm:block" onClick={() => navigate('/template20/profile')} />
                            <Heart className="w-5 h-5 text-slate-700 cursor-pointer hover:text-slate-900 transition-colors hidden sm:block" />
                            <div className="relative cursor-pointer" onClick={() => navigate('/template20/cart')}>
                                <ShoppingBag className="w-5 h-5 text-slate-700 hover:text-slate-900 transition-colors" />
                                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-600 text-white text-[10px] rounded-full flex items-center justify-center font-bold">0</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <div className="lg:hidden bg-white border-t border-slate-100">
                        <nav className="px-4 py-6 space-y-4">
                            <button onClick={() => { navigate('/template20/shop'); setMobileMenuOpen(false); }} className="block text-base font-medium text-slate-800">Shop All</button>
                            <button className="block text-base font-medium text-slate-800">Brands</button>
                            <button className="block text-base font-medium text-slate-800">Women</button>
                            <button className="block text-base font-medium text-slate-800">Men</button>
                            <button onClick={() => { navigate('/template20/contact'); setMobileMenuOpen(false); }} className="block text-base font-medium text-slate-800">Contact</button>
                        </nav>
                    </div>
                )}
            </header>

            {/* Hero Section */}
            <section className="relative h-[85vh] bg-slate-900">
                <img
                    src="https://images.unsplash.com/photo-1558171813-4c088753af8f?w=1920&h=1080&fit=crop"
                    alt="Hero"
                    className="w-full h-full object-cover opacity-50"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/80 to-transparent"></div>

                <div className="absolute inset-0 flex items-center">
                    <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 w-full">
                        <div className="max-w-2xl">
                            <p className="text-slate-400 text-sm tracking-[0.3em] mb-4">50+ PREMIUM BRANDS</p>
                            <h1 className="text-5xl lg:text-7xl font-black text-white mb-6 leading-[0.95]">
                                YOUR STYLE,<br />
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">ONE DESTINATION</span>
                            </h1>
                            <p className="text-slate-300 text-lg mb-8 max-w-lg">
                                Shop authentic products from FabIndia, BIBA, W, Manyavar, and 50+ more premium brands. All in one place.
                            </p>
                            <div className="flex flex-wrap gap-4">
                                <button
                                    onClick={() => navigate('/template20/shop')}
                                    className="group px-8 py-4 bg-white text-slate-900 font-bold tracking-wide hover:bg-slate-100 transition-colors inline-flex items-center gap-2"
                                >
                                    SHOP NOW <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                                </button>
                                <button className="px-8 py-4 border border-white/30 text-white font-medium tracking-wide hover:bg-white/10 transition-colors">
                                    EXPLORE BRANDS
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Bar */}
            <section className="bg-slate-50 py-4 border-b border-slate-200">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-16">
                        {services.map((service, idx) => (
                            <div key={idx} className="flex items-center gap-3">
                                <service.icon className="w-5 h-5 text-slate-700" />
                                <div>
                                    <span className="font-semibold text-slate-800 text-sm">{service.title}</span>
                                    <span className="text-slate-500 text-sm ml-2 hidden md:inline">{service.desc}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Shop by Category */}
            <section className="py-16 lg:py-24">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex items-end justify-between mb-10">
                        <div>
                            <p className="text-slate-500 text-sm tracking-wider mb-2">SHOP BY</p>
                            <h2 className="text-3xl lg:text-4xl font-black text-slate-900">Category</h2>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
                        {categories.map((cat, idx) => (
                            <div key={idx} className="group cursor-pointer relative overflow-hidden">
                                <div className="aspect-[4/5] overflow-hidden">
                                    <img
                                        src={cat.image}
                                        alt={cat.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/30 to-transparent"></div>
                                <div className="absolute bottom-0 left-0 right-0 p-6">
                                    <h3 className="text-3xl font-black text-white mb-1">{cat.name}</h3>
                                    <p className="text-slate-300 text-sm">{cat.count} products</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Featured Brands */}
            <section className="py-16 lg:py-24 bg-slate-50">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex items-end justify-between mb-10">
                        <div>
                            <p className="text-slate-500 text-sm tracking-wider mb-2">SHOP FROM</p>
                            <h2 className="text-3xl lg:text-4xl font-black text-slate-900">Premium Brands</h2>
                        </div>
                        <button className="hidden md:flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                            View All <ChevronRight className="w-4 h-4" />
                        </button>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                        {featuredBrands.map((brand, idx) => (
                            <div key={idx} className="group cursor-pointer bg-white overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300">
                                <div className="aspect-[3/2] overflow-hidden">
                                    <img
                                        src={brand.image}
                                        alt={brand.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    />
                                </div>
                                <div className="p-3 text-center">
                                    <h3 className="font-bold text-slate-800 text-sm">{brand.name}</h3>
                                    <p className="text-xs text-slate-500">{brand.products} products</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Products Grid */}
            <section className="py-16 lg:py-24">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 mb-10">
                        <div>
                            <p className="text-slate-500 text-sm tracking-wider mb-2">TRENDING</p>
                            <h2 className="text-3xl lg:text-4xl font-black text-slate-900">Bestsellers</h2>
                        </div>

                        {/* Brand Filter */}
                        <div className="flex items-center gap-2 flex-wrap">
                            {brands.map(brand => (
                                <button
                                    key={brand.id}
                                    onClick={() => setActiveBrand(brand.id)}
                                    className={`px-4 py-2 text-sm font-medium rounded-full transition-all ${
                                        activeBrand === brand.id
                                            ? 'bg-slate-900 text-white'
                                            : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                                    }`}
                                >
                                    {brand.name}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
                        {products.map((product, idx) => (
                            <div
                                key={idx}
                                className="group bg-white border border-slate-100 hover:border-slate-200 hover:shadow-lg transition-all duration-300"
                                onMouseEnter={() => setHoveredProduct(idx)}
                                onMouseLeave={() => setHoveredProduct(null)}
                            >
                                <div className="relative aspect-[3/4] overflow-hidden bg-slate-50">
                                    <img
                                        src={hoveredProduct === idx ? product.hoverImage : product.image}
                                        alt={product.name}
                                        className="w-full h-full object-cover transition-all duration-500"
                                    />
                                    {product.tag && (
                                        <span className={`absolute top-3 left-3 text-white text-[10px] font-bold tracking-wider px-2 py-1 ${
                                            product.tag === 'Bestseller' ? 'bg-green-600' :
                                            product.tag === 'Sale' ? 'bg-red-600' :
                                            product.tag === 'New' ? 'bg-blue-600' :
                                            'bg-purple-600'
                                        }`}>{product.tag.toUpperCase()}</span>
                                    )}
                                    <button className="absolute top-3 right-3 w-8 h-8 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 shadow-sm">
                                        <Heart className="w-4 h-4 text-slate-600" />
                                    </button>
                                    <button className="absolute bottom-3 left-3 right-3 py-3 bg-slate-900 text-white text-xs font-bold tracking-wider opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 flex items-center justify-center gap-2">
                                        <Plus className="w-4 h-4" /> ADD TO BAG
                                    </button>
                                </div>
                                <div className="p-4">
                                    <div className="flex items-center justify-between mb-1">
                                        <span className="text-xs font-semibold text-blue-600">{product.brand}</span>
                                        <div className="flex items-center gap-1">
                                            <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
                                            <span className="text-xs text-slate-600">{product.rating}</span>
                                        </div>
                                    </div>
                                    <h3 className="text-sm font-medium text-slate-800 mb-2">{product.name}</h3>
                                    <div className="flex items-center gap-2">
                                        <span className="text-base font-bold text-slate-900">₹{product.price.toLocaleString()}</span>
                                        <span className="text-sm text-slate-400 line-through">₹{product.originalPrice.toLocaleString()}</span>
                                        <span className="text-xs text-green-600 font-medium">{Math.round((1 - product.price/product.originalPrice) * 100)}% off</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-12">
                        <button
                            onClick={() => navigate('/template20/shop')}
                            className="group px-8 py-4 bg-slate-900 text-white font-bold tracking-wide hover:bg-slate-800 transition-colors inline-flex items-center gap-2"
                        >
                            VIEW ALL PRODUCTS <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </button>
                    </div>
                </div>
            </section>

            {/* Trust Banner */}
            <section className="bg-slate-900 py-12">
                <div className="max-w-screen-xl mx-auto px-4 lg:px-8 text-center">
                    <Grid3X3 className="w-10 h-10 text-blue-400 mx-auto mb-4" />
                    <h2 className="text-2xl lg:text-3xl font-black text-white mb-4">
                        100% Authentic Products
                    </h2>
                    <p className="text-slate-400 max-w-xl mx-auto">
                        Every product on Supreme is sourced directly from authorized brand partners. Shop with confidence.
                    </p>
                </div>
            </section>

            {/* Reviews */}
            <section className="py-16 lg:py-24 bg-slate-50">
                <div className="max-w-screen-xl mx-auto px-4 lg:px-8">
                    <div className="text-center mb-12">
                        <p className="text-slate-500 text-sm tracking-wider mb-2">REVIEWS</p>
                        <h2 className="text-3xl lg:text-4xl font-black text-slate-900">What Our Customers Say</h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {reviews.map((review, idx) => (
                            <div key={idx} className="bg-white p-6 shadow-sm">
                                <div className="flex gap-1 mb-4">
                                    {[...Array(review.rating)].map((_, i) => (
                                        <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                                    ))}
                                </div>
                                <p className="text-slate-700 mb-4 leading-relaxed">"{review.text}"</p>
                                <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                                    <div className="w-10 h-10 bg-slate-200 rounded-full flex items-center justify-center">
                                        <span className="text-slate-700 font-bold">{review.name.charAt(0)}</span>
                                    </div>
                                    <div>
                                        <p className="font-bold text-slate-800 text-sm">{review.name}</p>
                                        <p className="text-slate-500 text-xs">{review.city}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Newsletter */}
            <section className="py-16 lg:py-20 bg-white">
                <div className="max-w-xl mx-auto px-4 text-center">
                    <h2 className="text-2xl lg:text-3xl font-black text-slate-900 mb-4">Join the Club</h2>
                    <p className="text-slate-600 mb-8">
                        Subscribe for exclusive deals, new arrivals, and insider access to sales.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <input
                            type="email"
                            placeholder="Enter your email"
                            className="flex-1 px-5 py-4 bg-slate-100 border-0 text-slate-900 text-sm placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-300"
                        />
                        <button className="px-8 py-4 bg-slate-900 text-white text-sm font-bold tracking-wide hover:bg-slate-800 transition-colors">
                            SUBSCRIBE
                        </button>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-slate-900 text-white">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 py-12 lg:py-16">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
                        <div>
                            <h3 className="text-2xl font-black mb-4">SUPREME</h3>
                            <p className="text-slate-400 text-sm leading-relaxed">
                                India's premium multi-brand fashion destination. 50+ brands, 10,000+ products.
                            </p>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-slate-300">SHOP</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template20/shop')} className="text-slate-400 hover:text-white cursor-pointer transition-colors">All Products</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">Women</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">Men</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">Kids</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-slate-300">HELP</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template20/contact')} className="text-slate-400 hover:text-white cursor-pointer transition-colors">Contact</span></li>
                                <li><span onClick={() => navigate('/template20/orders')} className="text-slate-400 hover:text-white cursor-pointer transition-colors">Track Order</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">Returns</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">FAQ</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-slate-300">CONNECT</h4>
                            <ul className="space-y-2 text-sm">
                                <li className="text-slate-400">support@supreme.in</li>
                                <li className="text-slate-400">1800-123-4567</li>
                                <li className="text-slate-400 pt-2">Mon - Sun: 9am - 9pm</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-slate-500 text-xs">© 2025 Supreme. All rights reserved.</p>
                        <div className="flex gap-6 text-xs text-slate-500">
                            <span className="hover:text-white cursor-pointer transition-colors">Privacy</span>
                            <span className="hover:text-white cursor-pointer transition-colors">Terms</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Template20;
